<button class="dataset-item d-flex w-100 flex-nowrap align-items-center ps-2" data-uit="dataset-item" (click)="onClick.emit()" type="button">
    <div [caTruncate]="400" class="w-100 d-flex justify-content-between flex-nowrap" [ngClass]="{ 'w-50': !isFolder }" style="width: 400px">
        <div [caTruncate]="400" class="text-truncate d-flex w-100 pe-2 align-items-center">
            <div [caTruncate]="320" class="text-truncate d-flex align-items-center me-auto w-100">
                <ca-icon name="folder" size="s" class="me-2"></ca-icon>
                <span [caTruncate]="320" data-uit="dataset-item-name" class="text-truncate" placement="top" ngbTooltip="{{ name }}">{{ name }}</span>
            </div>
            <small
                class="number-of-files w-50 text-end"
                *ngIf="numberOfFiles != null"
                [ngClass]="{ 'text-danger': numberOfInvalidFiles && numberOfInvalidFiles > 0 && filesTableMode != FILE_EXPLORER_MODE.SELECTION }"
            >
                (<ca-number-of-files [numberOfFiles]="numberOfFiles"></ca-number-of-files>
                <ng-container *ngIf="numberOfInvalidFiles != null && numberOfInvalidFiles > 0 && filesTableMode != FILE_EXPLORER_MODE.SELECTION"
                    >, <ca-number-of-files [numberOfFiles]="numberOfInvalidFiles"></ca-number-of-files>
                    {{ 'GENERAL.COULD_NOT_BE_ADDED' | translate }}</ng-container
                >)
            </small>
        </div>
        <ng-content select="[actions]"></ng-content>
    </div>
</button>
